import React from 'react';
import FormattedNumber from 'components/FormattedNumber';
import FieldIcon from 'components/Icons/FieldIcon';
import HighlightedText from 'components/HighlightedText';
import { TREE_PADDING, COLORS, ICON_SIZES } from '../../constants';
import {
  getArchivedTextColor,
  getNonArchivedTextColor,
  getArchivedFieldIconColor,
  getNonArchivedFieldIconColor,
  pluralize
} from '../../helpers';
import ArchivedLabel from '../ArchivedLabel';
import TreeItemWrapper from '../TreeItemWrapper';

interface FieldTreeItemProps {
  id: string;
  name: string;
  geometry: any;
  archivedState: {
    isArchived: boolean;
    showLabel?: boolean; // Only show label if field itself is archived
  };
  stats: {
    cropZoneCount: number;
    totalAcres: number;
  };
  onClick: () => void;
  paddingClass?: string;
  searchTerm?: string;
}

const FieldTreeItem: React.FC<FieldTreeItemProps> = ({
  id,
  name,
  geometry,
  archivedState,
  stats,
  onClick,
  paddingClass = TREE_PADDING.FIELD,
  searchTerm = ''
}) => {
  const { isArchived, showLabel: showArchivedLabel } = archivedState;
  const { cropZoneCount, totalAcres } = stats;
  return (
    <TreeItemWrapper paddingClass={paddingClass} onClick={onClick}>
      <div className="flex items-start overflow-hidden">
        <FieldIcon
          id={`field-icon-${id}`}
          features={
            geometry
              ? [
                  {
                    type: 'Feature',
                    geometry,
                    properties: {}
                  }
                ]
              : []
          }
          width={ICON_SIZES.FIELD}
          height={ICON_SIZES.FIELD}
          color={
            isArchived
              ? getArchivedFieldIconColor()
              : getNonArchivedFieldIconColor()
          }
        />
        <div className="ml-2 overflow-hidden">
          <div className="flex items-center">
            <HighlightedText
              text={name}
              searchTerm={searchTerm}
              className="font-medium leading-5"
              style={{
                marginRight: showArchivedLabel ? '2px' : '0',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                wordBreak: 'break-word',
                color: isArchived ? COLORS.ARCHIVED_TEXT : undefined
              }}
            />
            {showArchivedLabel && <ArchivedLabel />}
          </div>
          <p
            className="mt-2px text-xs leading-3 whitespace-nowrap"
            style={{
              color: isArchived
                ? getArchivedTextColor()
                : getNonArchivedTextColor()
            }}
          >
            {cropZoneCount} {pluralize(cropZoneCount, 'crop zone')} ·{' '}
            <FormattedNumber roundedTo={2}>{totalAcres}</FormattedNumber> ac
          </p>
        </div>
      </div>
    </TreeItemWrapper>
  );
};

export default FieldTreeItem;
